module.exports = __webpack_public_path__ + "static/img/samajuri (1).122c123.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (1).jpg
// module id = 5vek
// module chunks = 0